import React, { useState } from "react";
import { useProjectAttachments } from "../../../data/project-attachments";
import { useAttachmentDisplay } from "../../../lib/attachments/attachments";
import { HttpAttachment } from "tekkr-common/dist/model/attachments";
import { FilePreview, isFileAttachment } from "./attachment-list";
import { Tooltip, TooltipContent, TooltipTrigger } from "../../../components/ui/tooltip";

interface Props {
    target: string[];
}

export function FileAttachmentIndicator({ target }: Props) {
    const { getAttachments } = useProjectAttachments();
    const attachments = getAttachments(target);
    const file = attachments[0] ?? null;

    if (!file) {
        return null;
    }

    return <FileIndicatorIcon file={file} />;
}

function FileIndicatorIcon({ file }: { file: HttpAttachment }) {
    const [showFilePreview, setShowFilePreview] = useState(false);
    const { icon: Icon, url } = useAttachmentDisplay(file);
    const isFile = isFileAttachment(file);

    const handleClick = (e: React.MouseEvent) => {
        e.stopPropagation();
        e.preventDefault();
        if (isFile) {
            setShowFilePreview(true);
        } else if (url) {
            window.open(url, "_blank", "noreferrer");
        }
    };

    const handleClosePreview = () => {
        setShowFilePreview(false);
    };

    return (
        <div onClick={(e) => e.stopPropagation()}>
            {showFilePreview && isFile && <FilePreview attachment={file} onClose={handleClosePreview} />}
            <Tooltip delayDuration={200}>
                <TooltipTrigger asChild>
                    <div
                        onClick={handleClick}
                        className={
                            "cursor-pointer rounded p-0.5 text-muted-foreground transition-all hover:bg-accent hover:text-foreground"
                        }
                    >
                        <Icon className={"h-4 w-4"} />
                    </div>
                </TooltipTrigger>
                <TooltipContent side="top">
                    <p className={"text-xs"}>{file.name}</p>
                </TooltipContent>
            </Tooltip>
        </div>
    );
}
